import { IconButton, Typography } from 'fronton-react';
import { XCircleIcon } from '@fronton/icons-react';
import React from 'react';
import { Skeleton } from 'fronton-react/unstable';
import { useTranslation } from 'react-i18next';
import { getTintLabel } from '../../helpers/get-tint-label.helper';
import { TTintColor } from '../../types';
import { tintPriceSkeleton } from './styles';

type TProps = {
  activeTintColor: TTintColor | null;
  countOfSelectedColors: number;
  handleDeleteColor: () => void;
  isTintServicePriceLoading: boolean;
};

export const TintLabel = ({
  activeTintColor,
  countOfSelectedColors,
  handleDeleteColor,
  isTintServicePriceLoading,
}: TProps) => {
  const { t } = useTranslation();

  const isActiveColor = activeTintColor !== null;

  return (
    <>
      {isTintServicePriceLoading && (
        <Skeleton data-qa="tint-label-skeleton-pdp" className={tintPriceSkeleton} />
      )}

      <Typography data-qa="tint-label-pdp" variant="caption" color="text-secondary">
        {getTintLabel({
          activeTintColor,
          countOfSelectedColors: countOfSelectedColors,
          tintServiceLabel: t('product-info.pdp-select-tint-color.label'),
          noTintLabel: t('product-info.pdp-select-tint-color.no_tint_label'),
          isTintServicePriceLoading,
        })}
      </Typography>

      {isActiveColor && (
        <IconButton
          data-qa="delete-tint-color-pdp"
          onClick={handleDeleteColor}
          aria-label={t('product-info.pdp-select-tint-color.aria_labels.cancel_color_select')}
          size="s"
        >
          <XCircleIcon type="fill" size="s" color="b2b-primary" />
        </IconButton>
      )}
    </>
  );
};
